export default String.raw`
.news {
    padding: 0 5%;

    &__header {
        h2 {
            @include h3-headline;
        }
    }

    &__swiper {
        overflow-x: visible;
    }

    &__arrows {
        visibility: hidden;
    }

    &__slide {
        width: calc(100% / 1.5);
    }
}
`